import React, { useLayoutEffect, useState } from "react";
import RotaDoDiaLayout from "../components/Layout/RotaDoDiaLayout";

import { useConfigureFooter } from "~hooks/useHelpers";
import RotaDoDiaFiltroVisitas from "../components/Filtros/RotaDoDiaFiltroVisitas";
import RotaDoDiaListagemVisitas from "../components/Listagem/RotaDoDiaListagemVisitas";
import "../style.scss";
import useVisitas from "~fetchs/Roterizacao/useVisitas";
import { useGetVisitas } from "~hooks/useSincronizacao";
import useDefaultFetch from "~fetchs/useDefaultFetch";

import useRouteFilter from "../hooks/useRouteFilter";
import useVendedor from "~fetchs/useVendedor";

const RotaDoDiaVisitas = () => {
  const [skip, setSkip] = useState(0);
  const take = 10;
  const [isLoading, setIsLoading] = useState(false);
  const [enabled, setEnabled] = useState(false);
  const { filters, setFilters, cleanFilters } = useRouteFilter();

  useDefaultFetch({
    useGet: useGetVisitas,
    table: "visitas",
    enabled: enabled,
  });

  useLayoutEffect(() => {
    setEnabled(true);
  }, []);

  const { vendedorSelecionado } = useVendedor();

  const { visitas, totalRenderizado, total, uniqueLocais } = useVisitas({ skip, take, filters, vendedorSelecionado });

  useConfigureFooter({ notDeveloped: false });
  return (
    <RotaDoDiaLayout>
      <RotaDoDiaFiltroVisitas
        filters={filters}
        setFilters={setFilters}
        cleanFilters={cleanFilters}
        uniqueLocais={uniqueLocais}
      />

      <RotaDoDiaListagemVisitas
        totalRenderizado={totalRenderizado}
        total={total}
        setSkip={setSkip}
        take={take}
        skip={skip}
        visitas={visitas}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        setFilters={setFilters}
        filters={filters}
      />
    </RotaDoDiaLayout>
  );
};

export default RotaDoDiaVisitas;
